import ConfirmationDialogContacts from 'components/atoms/ConfirmationDialogContacts'
import ModalWindow from 'components/molecules/ModalWindow'
import { CONSTS } from 'config/objectConst'
import { notificationHooks } from 'features/notifications'
import { useSwitcher } from 'shared/hooks'
import { useConfirmState } from 'shared/odata/confirm'
import { type ContactsTable, LoadingButton, StackIcon } from 'shared/ui'

import { api } from '../../api'

export function DeleteContacts({
	amount = 0,
	filters,
	unSelectAll
}: Pick<
	ContactsTable.Types.ActionsProps,
	'amount' | 'filters' | 'unSelectAll'
>) {
	const confirmSwitcher = useSwitcher(false)

	const [validate, validateOptions] = api.useLazyValidateDeleteContactsQuery()
	const [deleteMutations, deleteOptions] = api.useDeleteContactsMutation()

	const snack = notificationHooks.useSnack()
	const confirmState = useConfirmState()

	const deleteContacts = async () => {
		const { data } = await deleteMutations(filters)
		unSelectAll()
		if (data !== undefined) {
			snack('3.20')
		}
	}

	return (
		<>
			<LoadingButton
				isLoading={validateOptions.isLoading || deleteOptions.isLoading}
				onClick={async () => {
					const { data } = await validate(filters)
					if (!data) {
						return
					}

					const isValid = data.validation_rules_summary.length === 0

					if (isValid) {
						return confirmSwitcher.on()
					}

					return confirmState.set({
						data,
						id: null,
						status: true
					})
				}}
				variant='danger'
			>
				<StackIcon icon='trash' width={18} />
				Delete
			</LoadingButton>

			<ModalWindow
				closeHandler={confirmSwitcher.off}
				closeText='No'
				confirmHandler={deleteContacts}
				confirmText='Yes'
				loading={deleteOptions.isLoading}
				content={CONSTS.confirmationDialogs[1.9].content.replace(
					'{contacts_count}',
					amount.toString()
				)}
				open={confirmSwitcher.isOn}
				title={CONSTS.confirmationDialogs[1.9].title.replace(
					'{contacts_count}',
					amount.toString()
				)}
			/>

			<ModalWindow
				classes={'confirmation-launch-modal'}
				closeHandler={confirmState.reset}
				open={confirmState.state.status}
			>
				<ConfirmationDialogContacts
					closeHandler={confirmState.reset}
					confirmationDialogContacts={confirmState.state}
					deleted={deleteContacts}
				/>
			</ModalWindow>
		</>
	)
}
